module.exports = __webpack_public_path__ + "KaTeX_SansSerif-Regular.48936afa.ttf";